import styled from 'styled-components';

export const PageContainer = styled.div`
  margin-top: 76px;
  padding: 40px 24px;
`;
